import React, { useState, useEffect } from 'react';
import { Layout } from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function DesignerPatterns() {
  const { t } = useLanguage();
  const [url, setUrl] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/designs/settings`, { withCredentials: true })
      .then(res => setUrl(res.data.patterns_url || ''))
      .catch(() => {});
  }, []);

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-2xl font-semibold text-slate-900">Patterns PANTHER</h1>
        <Card className="border-slate-200 shadow-sm">
          <CardContent className="text-center py-12">
            <a href={url || '#'} target="_blank" rel="noreferrer">
              <Button size="lg" className="bg-slate-900 hover:bg-slate-800 gap-2">
                <ExternalLink size={18} /> {t('open_patterns_dropbox')}
              </Button>
            </a>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
